export enum BillingPeriod {
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  HALFYEARLY = 'HALF YEARLY'
}